import { render } from "./ExampleQueries.vue?vue&type=template&id=0cacefa6&scoped=true&ts=true"
import script from "./ExampleQueries.vue?vue&type=script&lang=ts"
export * from "./ExampleQueries.vue?vue&type=script&lang=ts"

import "./ExampleQueries.vue?vue&type=style&index=0&id=0cacefa6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cacefa6"]])

export default __exports__